class Search_Open {
  constructor () {
    this.searchWrapper = document.querySelector('.header-search');
    this.searchForm = document.querySelector('.jsHeaderSearchForm');
    this.searchInput = document.querySelector('.jsHeaderSearchForm .field__input');
    
    this.searchButton = document.querySelector('.jsHeaderSearchButton');
    this.cancelButton = document.querySelector('.jsHeaderSearchCancelButton');

    this.isOpen = false;

    this.initListener();
  }

  initListener () {
    this.searchButton.addEventListener( 'click', () => {
      if( !this.isOpen ) {
          this.isOpen = this.searchWrapper.classList.toggle('header-search--open');
      }else if( this.searchInput.value !== '' ){
        this.searchForm.submit();
      }
    })
    this.cancelButton.addEventListener( 'click', () => {
      if( this.isOpen ) {
          this.isOpen = this.searchWrapper.classList.toggle('header-search--open');
          setTimeout( () => {
            this.searchWrapper.classList.add('header-search--closing');
          }, 600);
          setTimeout( () => {
            this.searchWrapper.classList.remove('header-search--closing');
          }, 800);
      }
    })
  }
}

window.addEventListener( 'load', () => {
  new Search_Open();
})